export default "__VITE_ASSET__C5OMl2Su__"